import { render, staticRenderFns } from "./docRepo.vue?vue&type=template&id=618be7f9&scoped=true"
import script from "./docRepo.vue?vue&type=script&lang=js"
export * from "./docRepo.vue?vue&type=script&lang=js"
import style0 from "./docRepo.vue?vue&type=style&index=0&id=618be7f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618be7f9",
  null
  
)

export default component.exports